import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getAvailableAccessRights} from 'src/openapi/admin/apis/GetAvailableAccessRightsApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectAvailableAdminRights} from './services/dictionary-slice';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

export const useAvailableAdminRights = () => {
    const apiDispatch = useAppDispatch();
    const availableAdminRights = useSelector(selectAvailableAdminRights);

    const loadAvailableAdminRights = useCallback(() => {
        if (!availableAdminRights.length) {
            apiDispatch(getAvailableAccessRights());
        }
    }, [availableAdminRights.length, apiDispatch]);

    const getAdminRightByCode = useCallback((code: string): DictionaryItem | undefined => {
        return availableAdminRights?.find(e => e.code === code);
    }, [availableAdminRights]);

    return {availableAdminRights, loadAvailableAdminRights, getAdminRightByCode};
};
